var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 15.1968C8.16709 15.1968 6.55609 14.2598 5.60809 12.8408C5.62609 11.3868 8.54009 10.5858 10.0001 10.5858C11.4601 10.5858 14.3701 11.3868 14.3921 12.8408C13.4441 14.2598 11.8331 15.1968 10.0001 15.1968ZM10.0001 4.8028C11.2111 4.8028 12.1961 5.7878 12.1961 6.9988C12.1961 8.2148 11.2111 9.1948 10.0001 9.1948C8.78909 9.1948 7.80409 8.2148 7.80409 6.9988C7.80409 5.7878 8.78909 4.8028 10.0001 4.8028Z",
    fill: "#303A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50012 0.5C1.39012 0.5 0.500122 1.39 0.500122 2.5V17.5C0.500122 18.605 1.39512 19.5 2.50012 19.5H17.5001C18.6051 19.5 19.5001 18.605 19.5001 17.5V2.5C19.5001 1.39 18.6001 0.5 17.5001 0.5H2.50012ZM2.50012 17.5H17.5001V2.473H2.50012V17.5Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9679bc994a7b19ef2091b3c31a5b2d00.svg";
export { ForwardRef as ReactComponent };